"use client";

interface JsonLdProps {
  encodedJson: string;
}

export default function JsonLd({ encodedJson }: JsonLdProps) {
  const json = new TextDecoder().decode(
    Uint8Array.from(atob(encodedJson), (character) => character.charCodeAt(0)),
  );

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json.replace(/</g, "\\u003c") }}
    />
  );
}
